import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

import { modalHide } from '../api/actions'

const CustomModal = ({ common: { modal }, modalHide }) => {

    const handleClick = () => {
        let notifier = document.getElementById('sound');
        if (notifier && !notifier.paused) {
            notifier.removeAttribute('loop');
            notifier.pause();
        }
        modalHide();
    };

    return (
        <Modal
            open={modal.open}
            onClose={modalHide}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 5,
                    textAlign: 'center'
                }}
            >
                <Typography id="modal-title" variant="h6" component="h2" sx={{ textAlign: 'center', mb: 2 }}>
                   {modal.title}
                </Typography>

                <Typography id="modal-description" sx={{ textAlign: 'center', mb: 4, fontSize: '1.1rem' }}>
                    {modal.text}
                </Typography>

                <Button onClick={handleClick} variant="contained" color="primary">
                    OK
                </Button>
            </Box>
        </Modal>
    )
}

CustomModal.propTypes = {
    common: PropTypes.object.isRequired,
    modalHide: PropTypes.func.isRequired
}

function ModalState(state) {
    return {
        common: state.common
    }
}

export default connect(ModalState, { modalHide })(CustomModal)
